let win;

if (typeof window !== "undefined") {
  win = window;
} else if (typeof globalThis !== "undefined") {
  win = globalThis;
} else if (typeof self !== "undefined") {
  win = self;
} else {
  win = {};
}

export default win;
